import { FileUploadRequest, FileActions } from "@/business/files/domain/files";
import { loadOrderService } from "@/business/files/infrastructure/services/loadOrderService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const loadOrder = {
    async execute(file: File): Promise<void> {
        const request: FileUploadRequest =
            FileActions().uploadFileRequest(
                file
            );
        await loadOrderService.execute(await tokenValidation.execute(), request);
    },
};